export const featuredRoutesDisplayLimit = 3;